import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Skeleton,
  Stack,
} from '@mui/material';

const SKELETON_ROWS = [0, 1, 2];

export const PendingInvitesListSkeleton = () => {
  return (
    <List disablePadding>
      {SKELETON_ROWS.map((index) => (
        <ListItem
          key={index}
          divider={index < SKELETON_ROWS.length - 1}
          sx={{
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            rowGap: 1,
          }}
        >
          <ListItemAvatar>
            <Skeleton variant="circular" width={40} height={40} />
          </ListItemAvatar>
          <ListItemText
            primary={<Skeleton width="40%" />}
            secondary={<Skeleton width="25%" />}
          />
          <Stack
            direction="row"
            spacing={1}
            sx={{
              ml: { sm: 2 },
              width: { xs: '100%', sm: 'auto' },
              justifyContent: { xs: 'flex-end', sm: 'flex-start' },
            }}
          >
            <Skeleton variant="rounded" width={72} height={31} />
            <Skeleton variant="rounded" width={72} height={31} />
          </Stack>
        </ListItem>
      ))}
    </List>
  );
};
